import { render, staticRenderFns } from "./uploadedList.vue?vue&type=template&id=6b873518&scoped=true&"
import script from "./uploadedList.vue?vue&type=script&lang=js&"
export * from "./uploadedList.vue?vue&type=script&lang=js&"
import style0 from "./uploadedList.vue?vue&type=style&index=0&id=6b873518&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b873518",
  null
  
)

export default component.exports